// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"8b2a9e80","769":"8eb31aec"}[chunkId] + ".chunk.js";
};